/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-attribute.reducer';

export const PatientAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientAttributeEntity = useAppSelector(state => state.patientAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientAttribute.detail.title">PatientAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.cursor}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.value}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.patientAttribute.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{patientAttributeEntity.comments}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttribute.type">Type</Translate>
          </dt>
          <dd>{patientAttributeEntity.type ? patientAttributeEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttribute.patient">Patient</Translate>
          </dt>
          <dd>{patientAttributeEntity.patient ? patientAttributeEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttribute.clinicalDictionary">Clinical Dictionary</Translate>
          </dt>
          <dd>{patientAttributeEntity.clinicalDictionary ? patientAttributeEntity.clinicalDictionary.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-attribute/${patientAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientAttributeDetail;
